export default __webpack_public_path__ + "static/bnb-2c9b20dc7f6cc5fd0c796512d2b8e267.svg";